import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Cookies from 'js-cookie';
const Logout = () => {
    const Navigate = useNavigate();
    useEffect(() => {
        const user_token = Cookies.get('user_token');
        const admin_token = Cookies.get('Admin_token');
        const surveyor_token = Cookies.get('Surveyor_token');
        if(user_token){
            Cookies.remove('user_token', { path: '/' });
        }
        if(admin_token){
            Cookies.remove('Admin_token', { path: '/' });
        }
        if(surveyor_token){
            Cookies.remove('Surveyor_token',{path: '/'});
        }

        Navigate('/login');
    },[Navigate]);
    
    return null;
}
 
export default Logout;

